import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useForm, useFetch } from '../../../../hooks'
import { FormHeader, FormFooter, FormBody, Form } from '../../../../modules/Form/styled';
import Buttons from '../../../../modules/Buttons';
import Button from '../../../../components/inputs/Button';
import DatePicker from '../../../../components/DatePicker';
import TextArea from '../../../../components/inputs/TextArea';
import FromInput from '../../../../components/inputs/FromInput';
import { pathOr } from 'ramda';

const FormAddEventPregnant = ({ cowid, cowno, endpoint, onClickCancel, onClickSave }) => {
    const [pregnant, setPregnant] = useState(280);
    const [date, setDate] = useState(moment().add(pregnant, 'days')._d);

    const { response, doFetch } = useFetch({
        url: `/${endpoint}`,
        method: 'POST'
    })

    useEffect(() => {
        doFetch({
            data: {
                cowno
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { fetching: fetchingQuickbuttonPregnant, doFetch: setQuickbuttonPregnant } = useFetch({
        method: 'POST'
    });

    useEffect(() => {
        const value = pathOr(null, ['data', 'step1', 'pregnant'], response);
        if(value !== null) {
            setPregnant(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response])

    const submit = async ({ note }) => {
        const res = await setQuickbuttonPregnant({
            url: `/rpc/${pathOr('', ['data', 'step1', 'endpoint'], response)}`,
            data: {
                cowid,
                unixtime: moment(date).unix(),
                note
            }
        })
        if (res === 0) {
            const errorMessage = pathOr(null, ['data', 'step2', 'error'], response);
            errorMessage && toast.error(errorMessage);
        } else {
            onClickSave(pathOr({}, ['data', 'step2'], response));
        }
    }


    const { values, errors, handleChange, handleSubmit, setValue } = useForm({
        callback: submit,
        initValues: { day: '0' }
    })

    const handleChangeDay = e => {
        handleChange(e);
        const diff = pregnant - parseInt(e.target.value, 10);
        if (diff >= 0) {
            setDate(moment().add(diff, 'days')._d);
        } else {
            setDate(moment()._d);
        }
    }

    const handleChangeDate = d => {
        setDate(d);
        const diff = moment(d).diff(moment(), 'days', true);
        if (diff >= 0) {
            setValue({ day: (pregnant - Math.ceil(diff)).toString() });
        } else {
            setValue({ day: pregnant.toString() });
        }
    };

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader alignLeft small>
                {pathOr('', ['data', 'step1', 'title'], response)}
            </FormHeader>
            <FormBody minHeight={false}>
                <FromInput
                    type="text"
                    label={pathOr('', ['data', 'step1', 'lblday'], response)}
                    name='day'
                    onChange={handleChangeDay}
                    value={values.day}
                    margin={'0 0 20px 0'}
                    maxWidth="100px"
                    maxLength={3}
                    pattern="\d*"
                    keyboardType="numeric"
                    returnKeyType="go"
                />
                <DatePicker
                    label={pathOr('', ['data', 'step1', 'lbldate'], response)}
                    selected={date}
                    onChange={handleChangeDate}
                    dateFormat="dd.MM.yyyy"
                    minDate={moment()._d}
                    maxDate={moment().add(pregnant, 'days')._d}
                />
                <TextArea
                    label={pathOr('', ['data', 'step1', 'lblnotes'], response)}
                    name='note'
                    placeholder={pathOr('', ['data', 'step1', 'placeholder'], response)}
                    onChange={handleChange}
                    value={values.note}
                    error={errors.note}
                />
            </FormBody>
            <FormFooter noMargin>
                <Buttons>
                    <Button
                        type='button'
                        onClick={onClickCancel}
                        width="50%"
                        disabled={fetchingQuickbuttonPregnant}
                    >
                       {pathOr('', ['data', 'step1', 'buttons', 'cancel'], response)}
                    </Button>
                    <Button
                        type='submit'
                        width="50%"
                        green
                        disabled={fetchingQuickbuttonPregnant}
                    >
                       {pathOr('', ['data', 'step1', 'buttons', 'save'], response)}
                    </Button>
                </Buttons>
            </FormFooter>
        </Form>
    )
};

export default FormAddEventPregnant;
